export default class ProjectHistoryData {

    constructor() {

        this.fullProjhist = {

            projects: [
                {
                    fromdate: "2024",
                    todate: "present",
                    title: "Auddia",
                    duration: "1 Year",
                    graphs: [
                        "Developed a very large audio processing Android library in C/C++ using the Android" +
                        "NDK to optimize performance and memory footprint. The library performed" +
                        "sophisticated DSP functions including Fourier Transforms to fingerprint and analyze" +
                        "incoming audio. The analysis included matrix math which I was able to optimize by" +
                        "employing hardware acceleration via the NEON instruction set in most modern Arm" +
                        "processors. Of course the code fell back to software matrix math in the absence of these" +
                        "hardware capabilities. To ingest the audio data I cross compiled a custom suite of" +
                        "FFmpeg libraries."
                    ],
                    industries: [
                        "Consumer",
                    ],
                    technologies: [
                        "Android", "NDK", "C/C++", "Kotlin", "FFmpeg", "Audio", "DSP", "FFT", "NEON"
                    ],
                    keywords: [
                        "Kotlin", "Androidx", "Jetpack", "Compose", "Readuim", "Unit Testing", "Instrumented Testing",
                        "Automated Testing"
                    ]
                },
                {
                    fromdate: "2022",
                    todate: "present",
                    title: "New York Public Library",
                    duration: "2+ Years",
                    graphs: [
                        "Developed Android book reader app to replace their existing legacy app. Utilized Jetpack" +
                        "Compose and the opensource library called Readium. I was also involved in testing using" +
                        "unit tests, instrumented tests and Appium/Webio drivers for automated testing in the" +
                        "cloud."
                    ],
                    industries: [
                        "Consumer",
                    ],
                    technologies: [
                        "Android", "Compose", "Coroutines", "Kotlin", "Hybrid", "Audio"
                    ],
                    keywords: [
                        "Kotlin", "Androidx", "Jetpack", "Compose", "Readuim", "Unit Testing", "Instrumented Testing",
                        "Automated Testing"
                    ]
                },
                {
                    fromdate: "2022",
                    todate: "2023",
                    title: "Davis Instruments - Embedded Android in Weather Station",
                    duration: "6 Months",
                    graphs: [
                        "Provided Android subject matter expertise to a firm using Android for the first time." +
                        "Assisted them in untangling their code in an embedded Android device. Provided" +
                        "architectural guidance and mentored developers on Kotlin, Coroutines and Android" +
                        "internals."
                    ],
                    industries: [
                        "Consumer",
                    ],
                    technologies: [
                        "Android", "Embedded", "C++", "Coroutines", "Kotlin",
                    ],
                    keywords: [
                        "Kotlin", "Androidx", "Jetpack", "C++", "Embedded",
                    ]
                },
                {
                    fromdate: "2020",
                    todate: "2022",
                    title: "Help-On - Developed complex networking Android app.",
                    duration: "16 Months",
                    graphs: [
                        "Lead a small team of android developers porting a video streaming utility app from an " +
                        "existing Android app to AndroidTV and FireTV/FireOS. New code was added in Kotlin " +
                        "and used Jetpack libraries with coroutines. Existing legacy code was Java. I implemented " +
                        "push notifications on both Android and FireOS devices using FCM and FCM respectively" +
                        "and utilizing AWS SNS to provide the client with a single point of transmission",
                        "Used Android’s VPNService to redirect network traffic to our in-house proxy servers. I " +
                        "was responsible for the underlying network code that intercepted DNS and streaming " +
                        "traffic, repackaged them, forwarded them and unpackaged the responses. Essentially we " +
                        "created an in-device DNS server.",
                        "Ported legacy PHP server code to Golang (Go Language) microservices and created the \n" +
                        "Docker containers that virtualized them in Google Cloud Services"
                    ],
                    industries: [
                        "Consumer",
                    ],
                    technologies: [
                        "Android", "Kotlin", "VPN", "VPNService", "golang", "Push Notifications"
                    ],
                    keywords: [
                        "Kotlin", "Androidx", "Jetpack", "Golang", "Firebase", "AWS SNS",
                    ]
                },
                {
                    fromdate: "2020",
                    todate: "2020",
                    title: "Myia Healthcare - Dedicated/ Android App.",
                    duration: "10 Months",
                    graphs: [
                        "Designed and lead team that built the v1.0 Android app for a healthcare startup. The app " +
                        "uses Bluetooth and Wi-Fi to collect biodata (Blood-Pressure, Blood Oxygen Saturation," +
                        "Weight, Sleep breathing patterns, etc., etc.) from patients and communicate them to " +
                        "central cloud-based servers for real-time analysis and alerting. The system is available to "+
                        "healthcare providers via subscription. The system was developed in Kotlin using many " +
                        "Jetpack libraries",
                        "Wrote several microservices in Golang (Go Language) that ran in Docker containers that " +
                        "were hosted at AWS.",
                    ],
                    industries: [
                        "Healthcare",
                    ],
                    technologies: [
                        "Android", "Kotlin", "BLE", "Bluetooth",
                    ],
                    keywords: [
                        "Kotlin", "Androidx", "Jetpack", "Golang"
                    ]
                },
                {
                    fromdate: "2020",
                    todate: "2020",
                    title: "Real-time video streaming system.",
                    duration: "5 Months",
                    graphs: [
                        "Programmed a video collection and streaming device based on Raspberry Pi 4’s and USB" +
                        "Webcams using V4L2 and programmed completely in Go/Golang.",
                        "Programmed video monitoring application for linux/RPi using OpenCV as a supervisor" +
                        "app including object and motion detection.",
                    ],
                    industries: [
                        "Security",
                    ],
                    technologies: [
                        "Embedded",
                    ],
                    keywords: [
                        "",
                    ]
                },
                {
                    fromdate: "2020",
                    todate: "2020",
                    title: " Improved existing Kotlin Android App.",
                    duration: "6 Months",
                    graphs: [
                        "Cleaned up significant clutter and technical debt that had accumulated in a healthcare" +
                        "Android app from numerous offshore developers over several years. Also helped debug" +
                        "issues occurring during GraphQl/Apollo API conversations.",
                        "Optimized data collection from both manual sources and multiple Bluetooth and wifi" +
                        "medical devices.",
                    ],
                    industries: [
                        "Healthcare",
                    ],
                    technologies: [
                        "Android", "Multimedia",
                    ],
                    keywords: [
                        "Kotlin", "Androidx", "Jetpack", "Golang"
                    ]
                },
                {
                    fromdate: "2020",
                    todate: "2020",
                    title: "Consulted on exoplayer for Android App.",
                    duration: "2 Months",
                    graphs: [
                        "Short-term consultation with a Startup Podcast publisher on best practices for use of the \n" +
                        "open source exoplayer media player for Android.",
                    ],
                    industries: [
                        "Consumer",
                    ],
                    technologies: [
                        "Android", "Multimedia",
                    ],
                    keywords: [
                        "Kotlin", "Androidx", "Jetpack"
                    ]
                },
                {
                    fromdate: "2019",
                    todate: "2020",
                    title: "Bechtel Corp. : Android App for world class construction firm.",
                    duration: "1 year",
                    graphs: [
                        "Served as Lead Android Developer managing a team of Android developers designing and developing an internal project management app for a world leading construction company. The app leverages most all of Google’s newest Android technologies. The app is written in Kotlin using two-way data binding, LiveData and other newest tech’s. The app communicates with multiple cloud servers using a combination of Apollo/GraphQL and REST service calls.",
                    ],
                    industries: [
                        "Construction",
                    ],
                    technologies: [
                        "Android", "REST",
                    ],
                    keywords: [
                        "Construction", "Kotlin", "Androidx", "Jetpack", "GraphQL", "Apollo",
                    ]
                },
                {
                    fromdate: "2018",
                    todate: "2019",
                    title: "Workinman/Vuzix : Android Apps for VR / HUD Device.",
                    duration: "1 year",
                    graphs: [
                        "I developed two apps for a new Android powered VR / HUD device. One interfaced via Bluetooth with a Golf swing analyzing device and displayed results in a Heads-Up view while allowing the player to maintain swing form.",
                        "The second app was a news aggregator that collected/organized and displayed news articles and videos from user defined sources. All display was in the Heads-Up-Display allowing the user to continue hands-free with other activities.",
                    ],
                    industries: [
                        "Consumer", "Entertainment"
                    ],
                    technologies: [
                        "Android", "REST", "AJAX", "Python", "SQLite",
                    ],
                    keywords: [
                        "VR", "Heads-Up-Display", "Video", "REST"
                    ]
                },
                {
                    fromdate: "2018",
                    todate: "",
                    title: "Video lister for car dealerships.",
                    duration: "1 year",
                    graphs: [
                        "Developed/Enhanced a pair of Android apps that allowed car dealerships to create and edit video clips of their automobile inventory. The dealer could build promotional apps with special effects, voice-overs and picture-in-picture enhancements. The videos could be posted to YouTube or other online services and viewing invitation could be sent to potential customers.",
                    ],
                    industries: [
                        "Automotive", "Salesforce", "Retail",
                    ],
                    technologies: [
                        "Android", "Java", "NDK", "C/C++", "OpenCV", "Computer Vision", "FFmpeg",
                    ],
                    keywords: [
                        "Automotive", "Video",
                    ]
                },
                {
                    fromdate: "2018",
                    todate: "",
                    title: "Activision : Retail Digital Signage Appliance.",
                    duration: "1 year",
                    graphs: [
                        "Developed a digital signage appliance from a SoiC based single-board-computer. I built a custom bootloader and Linux distro to support the device. On top of that I built a systems that displays videos and still images and responds to customer stimulus through pushbuttons and other user interface methodologies. The system currently supports automated content updating and infrastructure for internet based updates is included.",
                    ],
                    industries: [
                        "Consumer", "Wholesale", "Retail",
                    ],
                    technologies: [
                        "Embedded", "Linux", "Python", "FFmpeg", "Embedded Linux",
                    ],
                    keywords: [
                        "Signage", "Embedded", "IoT"
                    ]
                },
                {
                    fromdate: "2018",
                    todate: "",
                    title: "Startup developing a fleet management system for Intermodal Rail Yards.",
                    duration: "1 year",
                    graphs: [
                        "Developed Node.js/PostgreSql based servers to accept fleet positioning and status data via Android devices used for data collection and telemetry. Included was a web-based app for fleet status visualization by management. Developed two Android apps; one for vehicle and position collection and reporting and another app for mobile on-yard fleet and data visualization and management.",
                    ],
                    industries: [
                        "Trucking", "Marine", "Rail Transport", "Shipping"
                    ],
                    technologies: [
                        "Node.js", "AJAX", "SQL", "PostgreSQL", "Javascript", "Heroku", "Cloud", "Android", "Concurrency/Mutli-Threading"
                    ],
                    keywords: [
                        "Pet Care", "Embedded", "Proximity", "Threading", "Cloud", "Web"
                    ]
                },
                {
                    fromdate: "2017",
                    todate: "",
                    title: "Startup Client developing a Consumer Pet Care Device.",
                    duration: "1 year",
                    graphs: [
                        "Developed a PIC32MX bootloader that incorporates Wifi connectivity using Atmel (now Microchip) Winc1500 wifi module. My bootloader code enables remote Over-The-Air (OTA) firmware updates for both the device and the Winc module. Other code I developed allows wifi telemetry of device performance and health and for remote centralized command-and-control of the device. Also developed the OTA servers, the telemetry server, and the command-and-control server prototype. I also developed Android and Windows based bootloader companion apps that allow for serial firmware updates and for wifi manipulation of the device.",
                    ],
                    industries: [
                        "Consumer", "Embedded"
                    ],
                    technologies: [
                        "Microchip PIC uControllers", "Embedded WiFi", "SPI Bus", "I2C Bus", "Android", "Java", "C/C++",
                    ],
                    keywords: [
                        "Pet Care", "Embedded", "Proximity", "IoT"
                    ]
                },
                {
                    fromdate: "2016",
                    todate: "",
                    title: "IBM’s Thomas J. Watson Research Lab",
                    duration: "1+ years",
                    graphs: [
                        "Developed and evolved a machine learning system on which autonomous vehicle development is based. My development in the project involved using Android and other embedded devices to form a wireless network to acquire and share data using multiple sensors and computer vision.",
                    ],
                    industries: [
                        "Automotive", "Research and Development"
                    ],
                    technologies: [
                        "Android", "Java", "NDK", "C/C++", "OpenCV", "Computer Vision", "FFmpeg"
                    ],
                    keywords: [
                        "Autonomous Vehicle", "Machine Learning", "Computer Vision", "Video",
                    ]
                },
                {
                    fromdate: "2014",
                    todate: "2015",
                    title: "Confidential Legacy Client",
                    duration: "1+ years",
                    graphs: [
                        "Prototyped an internal route salesforce system for a legacy client using Xamarin Forms/Mono. The app served as the field front-end of a new automated just-in-time manufacturing/inventory system.",
                    ],
                    industries: [
                        "Wholesale", "Salesforce", "Manufacturing"
                    ],
                    technologies: [
                        "iOS", "Android", "Xamarin", "C#", ".Net", "GPS", "Barcode", "REST"
                    ],
                    keywords: [
                        "Sales", "Route", "GPS", "Location", "Web Service", "Hybrid"
                    ]
                },
                {
                    fromdate: "2014",
                    todate: "2019",
                    title: "Goodyear Tire and Rubber, Inc.",
                    duration: "6 years",
                    graphs: [
                        "Designed and developed a client/server system to manage and track the fleet of vehicles that service large localized operations. The system uses in-cab devices to report position and telemetry to a server, in real-time, via cellular networks. The system aides in maximize production while minimizing the consumption of fuel, as well as brake and tire wear. The system provides real-time feedback to the drivers to encourage optimum behaviors. Administrators can remotely view vehicle specific data in real-time on a web based map display and monitor driver performance.",
                    ],
                    industries: [
                        "Automotive", "Mining", "Navigation", "Fleet Management", "Fleet Tracking"
                    ],
                    technologies: [
                        "Windows Server", "Azure", "Cloud", "Android", "NDK", "C/C++", "REST", "ODBC-II", "CAN Bus", "Bluetooth", "RS-232", "GPS", "Sensor", "Location"
                    ],
                    keywords: [
                        "Automobile", "Truck", "GPS", "Location", "Web Service", "PIC", "CAN", "SPI", "I2C", "Bluetooth", "Command", "Control", "Web"
                    ]
                },
                {
                    fromdate: "2014",
                    todate: "",
                    title: "ITW Global Tire Repair Inc. makers of Slime and other automotive products.",
                    duration: "1 year",
                    graphs: [
                        "Developed hardware and firmware to acquire and decode CAN-Bus data from a motor vehicle’s OBD-II port. Data is analyzed and presented to the user via HUD and mobile device display.",
                    ],
                    industries: [
                        "Automotive", "Consumer",
                    ],
                    technologies: [
                        "Android", "NDK", "C/C++", "iOS", "Objective-C", "REST", "ODBC-II", "CAN Bus", "Bluetooth"
                    ],
                    keywords: [
                        "Automobile", "Car", "GPS", "Location", "Web Service", "PIC", "CAN", "SPI", "I2C", "Bluetooth"
                    ]
                },
                {
                    fromdate: "2013",
                    todate: "2014",
                    title: "Child security apps for a confidential start-up.",
                    duration: "2 years",
                    graphs: [
                        "Developed a suite of iOS and Android apps for a client that provides security services for families with children. Some of the apps use various location services in the background and relay position data to a central server. Other apps in the suite provide real time mapping and monitoring services. The mobile apps were developed using Xamarin/Mono in C# in order to share the business logic.",
                    ],
                    industries: [
                        "Consumer",
                    ],
                    technologies: [
                        "Android", "NDK", "C/C++", "iOS", "Objective-C", "Xamarin", "REST"
                    ],
                    keywords: [
                        "Safety", "security", "Child", "Children", "Family", "Parental", "GPS", "Location", "Web Service"
                    ]
                },
                {
                    fromdate: "2012",
                    todate: "",
                    title: "Neya Systems LLC.",
                    duration: "1 year",
                    graphs: [
                        "Developed an Android app that Streams “zero latency” real time video and audio for military applications. The app encodes video using H.264 video compression using the open source x264 video encoder. Streaming is accomplished using the Live555 open source library. Incoming video is decoded using the FFmpeg library which is also open source. All the open source libraries were ported to Android using the Android NDK (Java’s JNI) for C/C++ development. The video encoding used advance features of the h.264 standard to create a low and consistent (flat) bandwidth for transmission over slow media (ie long range RF, sonic thru water).",
                    ],
                    industries: [
                        "Robotics", "Defense", "Homeland Security"
                    ],
                    technologies: [
                        "Android", "NDK", "C/C++", "FFmpeg",
                    ],
                    keywords: [
                        "Video", "Streaming", "x264", "h264"
                    ]
                },
                {
                    fromdate: "2012",
                    todate: "",
                    title: "Wholesale Client.",
                    duration: "1 year",
                    graphs: [
                        "Developed a Windows Mobile/Phone app for Symbol Technologies Windows Mobile based barcode readers to be used in the wholesale industry. The project involved development of desktop .NET utilities to build/modify SQL Server CE database that are exchanged with the handheld devices.",
                    ],
                    industries: [
                        "Wholesale",
                    ],
                    technologies: [
                        "Windows Phone/Mobile/CE", ".Net", "C/C++", "Barcode"
                    ],
                    keywords: [
                        "Warehouse", "Wholesale", "Symbol Technologies", "Barcode Reader", "Inventory", "Desktop"
                    ]
                },
                {
                    fromdate: "2012",
                    todate: "",
                    title: "Medical Devices Manufacturer.",
                    duration: "1 year",
                    graphs: [
                        "Improved an Android Tablet application that controls an ophthalmological examination system. The android device allows the physician the freedom of motion while still maintaining control of the testing system. Control and configuration is via a Bluetooth wireless link. Data is exchanged through a combination of XML and proprietary protocols.",
                    ],
                    industries: [
                        "Medical", "Medical Devices",
                    ],
                    technologies: [
                        "Android", "Java", "C/C++", "Bluetooth"
                    ],
                    keywords: [
                        "Scientific", "Database", "Tablet", "Bluetooth"
                    ]
                },
                {
                    fromdate: "2011",
                    todate: "2012",
                    title: "Statistical Software Development Firm.",
                    duration: "1+ years",
                    graphs: [
                        "Developed prototype for a statistical analysis and presentation Application for the Apple iPad. The project involved development of a completely custom UI. The UI was graphics intensive.",
                    ],
                    industries: [
                        "Scientific & Engineering",
                    ],
                    technologies: [
                        "iOS", "Objective-C", "C/C++"
                    ],
                    keywords: [
                        "Statistical", "Statistics", "Scientific", "Database", "iPad"
                    ]
                },
                {
                    fromdate: "2011",
                    todate: "2013",
                    title: "Confidential Environmental Safety Equipment Manufacturer.",
                    duration: "2+ years",
                    graphs: [
                        "Data Analysis and Presentation/Visualization for a field usable Absorption Spectroscopic device. I maintain and enhance the data collection, analysis and visualization software that controls a field usable, absorption spectrograph used for discriminating both gaseous and particulate in long line-of-site paths. The device can be used for environmental, homeland security, or defense purposes. The software is written in C/C++.",
                    ],
                    industries: [
                        "Environmental", "Medical/Healthcare", "Scientific & Engineering", "Homeland Security", "Defense"
                    ],
                    technologies: [
                        "Windows", "MFC", "C/C++", "Concurrency", "Multi-Threading",
                    ],
                    keywords: [
                        "Environmental", "FFT", "Database", "Medicine", "Medical", "Healthcare", "Desktop"
                    ]
                },
                {
                    fromdate: "2011",
                    todate: "2012",
                    title: "Mobile Front End for Messaging system targeted at technologically challenged senior citizens.",
                    duration: "1+ year",
                    graphs: [
                        "I developed an iOS mobile App for a startup whos goal is to connect senior citizens to a variety of electronic messaging. It interfaces to a web server that aggregates electronic messages from various technologies. The client displays photos, plays videos and records and sends audio responses. Included the development of custom controls.",
                    ],
                    industries: [
                        "Consumer", "Medical/Healthcare"
                    ],
                    technologies: [
                        "Objective-C", "Concurrency", "Multi-Threading", "REST", "SQLite", "Database", "iOS",
                    ],
                    keywords: [
                        "Consumer", "Web Service", "API", "REST", "Database", "SQLite", "Medicine", "Medical", "Healthcare", "Emergency", "video", "audio"
                    ]
                },
                {
                    fromdate: "2011",
                    todate: "",
                    title: "Mobile Front End to locate nearby Emergency Healthcare facilities.",
                    duration: "1 year",
                    graphs: [
                        "iOS client assists user in locating the nearest emergency healthcare facities.",
                    ],
                    industries: [
                        "Consumer", "Medical/Healthcare"
                    ],
                    technologies: [
                        "Objective-C", "Concurrency", "Multi-Threading", "REST", "SQLite", "Database", "iOS",
                    ],
                    keywords: [
                        "Consumer", "Web Service", "API", "REST", "Database", "SQLite", "Medicine", "Medical", "Healthcare", "Emergency"
                    ]
                },
                {
                    fromdate: "2011",
                    todate: "",
                    title: "SyFy Television Network.",
                    duration: "1 year",
                    graphs: [
                        "I contributed to the development of both Android and iOS mobile Apps for a major cable network. My contribution included full development of the module(s) that retrieved/posted “viewer comments” from/to the API exposed by the networks website. This API returned XML data.",
                    ],
                    industries: [
                        "Consumer", "Entertainment"
                    ],
                    technologies: [
                        "Java", "Objective-C", "Concurrency", "Multi-Threading", "REST", "SQLite", "Database", "Android", "iOS",
                    ],
                    keywords: [
                        "Consumer", "Web Service", "API", "REST", "Database", "SQLite",
                    ]
                },
                {
                    fromdate: "2010",
                    todate: "2011",
                    title: "Hawaii Department of Tourism.",
                    duration: "1+ years",
                    graphs: [
                        "I contributed to the development of an Android mobile App for a major tourist destination State. I developed/completed code to retrieve up-to-date data in JSON format from a RESTful web service. After parsing and persistence in a local SQLite database the data is presented to the user as per various filtering algorithms. The data is periodically updated.",
                    ],
                    industries: [
                        "Consumer", "Navigation", "Entertainment"
                    ],
                    technologies: [
                        "Java", "Concurrency", "Multi-Threading", "REST", "SQLite", "Database", "MySQL", "Android", "GPS"
                    ],
                    keywords: [
                        "Consumer", "Web Service", "API", "REST", "Database", "SQL", "GPS", "tourism"
                    ]
                },
                {
                    fromdate: "2009",
                    todate: "present",
                    title: "Mobile Navigation for Maritime and Aeronautical applications.",
                    duration: "9+ years",
                    graphs: [
                        "Developed mobile nautical and aeronautical navigation systems on Android, Windows Mobile and iOS (iPhone and iPad). Involved decoding relatively complex file formats and high performance graphics display algorithms. Utilized sensor data such as GPS and compass for location and orientation information.",
                    ],
                    industries: [
                        "Navigation", "Aerospace", "Marine",
                    ],
                    technologies: [
                        "Linux", "C/C++", "Concurrency", "Multi-Threading", "REST", "SQL", "Database", "MySQL", "Android", "iOS", "Windows Phone/Mobile/CE", ".NET", "HTML", "CSS", "NDK", "GPS"
                    ],
                    keywords: [
                        "Consumer", "Web Service", "API", "REST", "Database", "SQL", "GPS", "SENSOR"
                    ]
                },
                {
                    fromdate: "2009",
                    todate: "2010",
                    title: "Cloud based productivity application with Mobile and Desktop Clients.",
                    duration: "1+ years",
                    graphs: [
                        "Developed a Web 2.0 Web app with HTML/CSS, PHP, JavaScript and MySQL. Created companion Desktop Clients in Java (Swing) and .NET. Also created Mobile Clients for Windows Mobile, Android. and iPhone/iPad.",
                    ],
                    industries: [
                        "Consumer", "Productivity"
                    ],
                    technologies: [
                        "Windows", "Linux", "C/C++", "C#", "Concurrency", "Multi-Threading", "PHP", "REST", "SQL", "Database", "MySQL", "Javascript", "Android", "iOS", "Windows Phone/Mobile/CE", ".NET", "HTML", "CSS"
                    ],
                    keywords: [
                        "Consumer", "Productivity", "Management", "Web Service", "API", "REST", "Database", "SQL", "dotNet", "Desktop", "Web"
                    ]
                },
                {
                    fromdate: "2008",
                    todate: "2009",
                    title: "Century 21 and Era Real Estate Networks.",
                    duration: "1+ years",
                    graphs: [
                        "Developed and enhanced back end services for the websites for the largest real estate agent networks in the world. Enhanced and added internal reporting for these same websites. Extensive C/C++ involved in the backend and middleware. Advanced PHP 4/5 on the front end for the UI portions.",
                    ],
                    industries: [
                        "Consumer", "Real Estate"
                    ],
                    technologies: [
                        "Windows", "Linux", "C/C++", "Concurrency", "Multi-Threading", "PHP", "REST", "SQL", "Database"
                    ],
                    keywords: [
                        "Consumer", "Productivity", "Management", "Web Service", "API", "REST", "Database", "Web"
                    ]
                },
                {
                    fromdate: "2008",
                    todate: "2009",
                    title: "eCommerce mobile applications.",
                    duration: "1+ years",
                    graphs: [
                        "Developed Windows Mobile CF .Net 1.x, 2.x and 3.5 and iPhone apps for online purchasing system. Developed Web services to feed data to mobile apps. Also created web back and front ends to manage eCommerce system.",
                    ],
                    industries: [
                        "Consumer",
                    ],
                    technologies: [
                        "Windows", "Linux", "iOS", "C/C++", "Concurrency", "Multi-Threading", "Windows Phone/Mobile/CE", "REST"
                    ],
                    keywords: [
                        "Consumer", "Productivity", "Management", "Web Service", "API", "REST"
                    ]
                },
                {
                    fromdate: "2007",
                    todate: "2008",
                    title: "Desktop and Handheld productivity app.",
                    duration: "1+ years",
                    graphs: [
                        "I was responsible for porting a desktop business productivity application from Windows XP/2000/NT to Windows Vista. I also implemented several enhancements to the system. I also enhanced the handheld companion application in Palm OS and ported it to Windows Mobile.",
                    ],
                    industries: [
                        "Consumer", "Productivity", "Management"
                    ],
                    technologies: [
                        "Windows", "Palm OS", "C/C++", "Concurrency", "Multi-Threading", "Windows Phone/Mobile/CE"
                    ],
                    keywords: [
                        "Consumer", "Productivity", "Management", "Desktop"
                    ]
                },
                {
                    fromdate: "2007",
                    todate: "2008",
                    title: "Continua Alliance; a Medical Device Industry Alliance.",
                    duration: "2 years",
                    graphs: [
                        "I worked for a couple of clients in the medical device industry. I was responsible for architecting/developing implementations of the IEEE 11073 which is the IEEE Standard for Medical Device Communications. This was designed and implemented as an embedded Linux system and as a universal library now available as open source.",
                    ],
                    industries: [
                        "Medical", "Medical Devices",
                    ],
                    technologies: [
                        "Windows", "linux", "embedded", "C/C++", "Concurrency", "Multi-Threading",
                    ],
                    keywords: [
                        "embedded", "open source", "API", "IoT"
                    ]
                },
                {
                    fromdate: "2006",
                    todate: "2007",
                    title: "Charles Schwab Performance Technologies.",
                    duration: "1 years",
                    graphs: [
                        "I was responsible for porting Charles Schwab’s existing portfolio management software to Windows Vista. This task included re-factoring much of the software and it’s installer to comply with Vista UAC security features. It further entailed re-working the Server software and the associated Windows Services written in C# and .Net to allow the service to interact with the GUI Desktop while complying with Windows Vista security requirements. I worked with the InstallShield engineer to modify the installation scripts to be Vista compliant. I also assisted in re-engineering sections the automated test environment to adjust for Vista changes. The project was expected to take 8 to 9 months. I successfully completed the project in slightly over 5 months. The product is successfully released to production/distribution.",
                    ],
                    industries: [
                        "Financial", "Financial Engineering",
                    ],
                    technologies: [
                        "Windows", "C/C++", "C#", ".Net", "Concurrency", "Multi-Threading", "BASIC", "SQL", "Database",
                    ],
                    keywords: [
                        "big data", "VB", "Desktop"
                    ]
                },
                {
                    fromdate: "2005",
                    todate: "2007",
                    title: "Jackson National Life Insurance Company.",
                    duration: "2+ years",
                    graphs: [
                        "I was responsible for developing and maintaining software for use by users within the company. I have been involved in large and small development teams that are responsible for systems related to document capture/storage/retrieval, Policy administration, and web/mainframe middleware. My work included Visual Basic, C, and mainly C++ under both Windows and various flavors of Unix/Linux. I have taken responsibility for several applications written in Visual C++ using MFC. I have enhanced and maintained all of these.",
                    ],
                    industries: [
                        "Insurance", "Financial", "Financial Engineering",
                    ],
                    technologies: [
                        "Windows", "Linux", "C/C++", "Concurrency", "Multi-Threading", "BASIC", "SQL", "Database", "Barcode Reading", "OCR",
                    ],
                    keywords: ["Desktop", "Server"]
                },
                {
                    fromdate: "2004",
                    todate: "2005",
                    title: "Confidential/Undisclosed Client.",
                    duration: "2 years",
                    graphs: [
                        "I developed an extensive software library to import, organize, co-relate and export massive amounts of Geographic Information System (GIS) data from various sources. Data included Digital Elevation data, TIGER line data representing political divisions, transportation features (i.e. roads, rail, ferries, etc), land usage and hydrography. Additionally, FAA data was overlaid to create highly accurate 3-D navigation data.",
                        "The project consisted of a central Windows/MFC application written in C++. The application dynamically incorporated plug-ins/codec’s (dll’s) that enabled the coding/decoding of various file formats comprising the universe of all possible data. The codec’s were also developed in C++ with MFC.",
                        "The data was first warehoused in a MySQL database. When MySQL was not providing sufficient performance, the data was migrated to a SQL Server database. Significant portions of the relational logic was embedded in the database (stored procedures) to allow future platforms (i.e. Java, VB, .NET) to manipulate the data without re-coding much of the relational rules.",
                    ],
                    industries: [
                        "Homeland Security", "Navigation", "Aerospace", "Trucking"
                    ],
                    technologies: [
                        "Windows", "Linux", "Android", "iOS", "C/C++", "Concurrency", "GIS", "SQL", "Database", "Geospatial"
                    ],
                    keywords: [
                        "geospatial", "mapping", "big data", "Desktop"
                    ]
                },
                {
                    fromdate: "2000",
                    todate: "2004",
                    title: "Thermo Fisher Scientific Corp (Formerly Thermo Scientific; Formerly Thermo Electron Corp).",
                    duration: "5 years",
                    graphs: [
                        "I did a series of projects for Thermo's Santa Fe, NM facility during this time period.",
                        "Thermo Scientifics Santa Fe, NM office develops Radiation Measurement and Protection Instruments and Systems.",
                        "My first project for Thermo was to develop the embedded software in a revolutionary portable Intelligent Radiation Measurement System trademarked as HandECount. This system broke new ground by embedding many of the algorithms that are used by health physics professionals directly in the measurement device. The device uploaded all of its data to a Windows based PC. I wrote both the Windows based transfer software and the Windows based management software used to analyze/archive the uploaded data as well as manage and calibrate the instrument. The instruments embedded software was all written in C. The transfer software and desktop application were developed in C++ using MFC. The system is used heavily at the Dept. of Energy’s national labs ( Los Alamos, Sandia, Savannah River, Oak Ridge, etc), at military installations, defense contractors and several nuclear power plants.",
                        "Another project I worked on for Thermo was as a technology consultant for their re-entry into the nuclear power plant supervisory, monitoring and control systems. In this capacity I advised them on various hardware, software and toolchain products that would allow them to build reliable and scalable products while bringing them to market efficiently.",
                        "The most recent project I completed for Thermo was the prototype for a Spectroscopic Radiation Detection Portal. This portal analyzes the spectrum of energies of the targets’ emitted particles and determines the makeup of the offending radioactive material. It can discriminate complex combinations of numerous isotopes and reliably report the constituent materials. The software that managed the multiple detector portion of the instrument was coded in C++ on an embedded Linux platform. The raw data was fed via TCP/IP to a windows server who ran the analytics engine. The Windows communications server was written in C++ using both MFC and the Win32 API. The analytics engine was written in FORTRAN."
                    ],
                    industries: [
                        "Defense", "Homeland Security", "Scientific and Engineering"
                    ],
                    technologies: [
                        "C/C++", "TCP/IP", "Embedded Linux", "Concurrency", "SBC",
                    ],
                    keywords: [
                        "Desktop"
                    ]
                }
            ]
        };
    }

    getTotalProjectCount() {
        return this.fullProjhist.projects.length;
    }
    getIndustriesList() {

        // Collect all industry keywords
        var words = ["Consumer","Navigation","Fleet Tracking","Fleet Management","Trucking","Shipping","Marine","Defense","Homeland Security"];
        for(var projidx in this.fullProjhist.projects) {
            var proj = this.fullProjhist.projects[projidx];
                var words = words.concat(proj.industries);
        }

        // cull duplicates
        var uniques = words.filter((elem, pos, arr) => arr.indexOf(elem) == pos);

        return uniques;
    }

    getTechnologiesList() {

        // Collect all industry keywords
        var words = [];
        for(var projidx in this.fullProjhist.projects) {
            var proj = this.fullProjhist.projects[projidx];
            var words = words.concat(proj.technologies);
        }

        // cull duplicates
        var uniques = words.filter((elem, pos, arr) => arr.indexOf(elem) == pos);

        return uniques;
    }

    getFilteredData(industrySelectors, techAnd, techSelectors, searchAnd, keywordSelectors) {
        console.log("************* getFilteredData() ********************");
        console.log(industrySelectors);
        console.log(techAnd);
        console.log(techSelectors);
        console.log(searchAnd);
        console.log(keywordSelectors);

/*
        if( industrySelectors.length == 0 && techSelectors.length == 0 && keywords.length == 0) {
            return this.fullProjhist.projects;
        }
*/

        const result = this.fullProjhist.projects.filter(proj => {
            var industryInclude = false;

            if(industrySelectors.length > 0) {
                for(var inputIdx in industrySelectors) {
                    var selector = industrySelectors[inputIdx];
                    for (var idx in proj.industries) {
                        if (proj.industries[idx].toLowerCase().indexOf(selector.toLowerCase()) != -1) {
                            industryInclude = true;
                        }
                    }
                }
            }

            var techInclude = false;
            if(techSelectors.length > 0) {
                for(var inputIdx in techSelectors) {
                    var selector = techSelectors[inputIdx];
                    for (var idx in proj.technologies) {
                        if (proj.technologies[idx].toLowerCase().indexOf(selector.toLowerCase()) != -1) {
                            techInclude = true;
                        }
                    }
                }
            }

            var keywordInclude = false;
            if(keywordSelectors.length > 0) {
                for(var inputIdx in keywordSelectors) {
                    var selector = keywordSelectors[inputIdx];
                    for (var idx in proj.keywords) {
                        if (proj.keywords[idx].toLowerCase().indexOf(selector.toLowerCase()) != -1) {
                            keywordInclude = true;
                        }
                    }
                }
            }

            var include = false;
            if(techAnd == true || techAnd === "true") {
                console.log("include = industryInclude && techInclude;")
                include = industryInclude && techInclude;
            } else {
                console.log("include = industryInclude || techInclude;")
                include = industryInclude || techInclude;
            }
            if(searchAnd == true || searchAnd === "true") {
                console.log("include = industryInclude && techInclude;")
                include = include && keywordInclude;
            } else {
                console.log("include = industryInclude || techInclude;")
                include = include || keywordInclude;
            }


            return include;
        });

        console.log(result);
        console.log("************* getFilteredData() ********************");
        return result;
    }
}


// WEBPACK FOOTER //
// src/ProjectHistory/ProjectHistoryData.js